import { usePintMaster, createControlField } from '@lib/common';
import { TextField } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import { useState, useEffect } from 'react';
import styled from 'styled-components';

const VitrinaContentStatusAutoComplete = ({ value, onChange }) => {
  /* const vitrinaContentStatusOptions = [
    { id: 0, name: 'Canceled' },
    { id: 1, name: 'Ended' },
    { id: 2, name: 'In Production' },
    { id: 3, name: 'Pilot' },
    { id: 4, name: 'Planned' },
    { id: 5, name: 'Post Production' },
    { id: 6, name: 'Released' },
    { id: 7, name: 'Returning Series' },
    { id: 8, name: 'Rumored' },
    { id: 9, name: 'Unknown' },
  ]; */

   const { loading, master: status } = usePintMaster('status');
    const [statusVal,setStatusVal] = useState(null);
  
    useEffect(() => {
      if(value && !loading && status) {
        const valueObj = status.filter(item => item?.name === (value?.name || value))
        setStatusVal(valueObj[0] || null)
      } else if (!value) {
        setStatusVal(null)
      }
    },[loading, value, status])

  return (
    <Styles>
      <Autocomplete
        size="small"
        fullWidth
        value={statusVal}
        onChange={(evt, v) => onChange && onChange(v)}
        options={status}
        getOptionLabel={option => option?.name ?? ''} // return string
        getOptionSelected={(option, value) => option.name === value.name} // ✅ v4 syntax
        renderInput={props => (
          <TextField
            helperText="Select vitrina content status"
            label={'Vitrina Content Status'}
            placeholder={'Vitrina Content Status'}
            fullWidth
            variant="outlined"
            {...props}
          />
        )}
      />
    </Styles>
  );
};

const Styles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

export const VitrinaContentStatusField = createControlField(VitrinaContentStatusAutoComplete, '');
